import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const importCSV = async (payload: FormData): Promise<Response> => {
  try {
    const uri = `${API_URL}/recipes/import`;
    const res = await fetch(uri, {
      method: 'POST',
      cache: 'reload',
      body: payload,
    });
    if (!res.ok) throw new Error(res.statusText);
    return res;
  } catch (e) {
    throw new Error('Could not import CSV', { cause: e });
  }
};
